import { Bool, Enum, Num, Obj, Str } from '@livecontrol/core-utils';
import { Device } from '../../../model';

export interface Record {
    id?: string;
    user?: {
      id?: string;
      organization_name?: string;
    };
    name?: string;
    nextEvent?: {
        id: string;
        name?: string;
        date_created?: string;
        start_time?: string;
        end_time?: string;
        status?: string;
        operator_name?: string;
    };
    eventHappening?: string;
    encoder_configs?: {
        ems_version?: string;
        lc_version?: string;
        splashtop_status?: string;
        bad_internet_speed_upload?: number;
        bad_internet_speed_download?: number;
    };
    screenshare?: string;
    encoder_status?: {
        date_updated?: string;
        online_status: boolean;
        internet_speed_download?: number;
        internet_speed_upload?: number;
    };
}

export const normalize = (record?: Record): Device | undefined => {

    const obj = {
        id: Str.normalize(record?.id),
        cid: Num.normalize(record?.user?.id),
        organization: Str.normalize(record?.user?.organization_name),
        location: Str.normalize(record?.name),
        // software: Str.normalize(record?.software),
        lcs: Str.normalize(record?.encoder_configs?.lc_version)?.replace(/^(ems|lcs) */i, '').split(' ').at(0) ?? '-', 
        ems: Str.normalize(record?.encoder_configs?.ems_version)?.replace(/^(ems|lcs) */i, '').split(' ').at(0) ?? '-',
        // nextDate: record?.nextEvent?.start_time ? new Date(record.nextEvent.start_time) : undefined,
        graphics: Str.normalize(undefined) ?? 'ProPresenter',
        session: Enum.normalize(Device.Session, record?.screenshare) ?? Device.Session.inactive,
        status: Bool.normalize(record?.encoder_status?.online_status) ? Device.Status.online : Device.Status.offline,
        statusUpdatedAt: Num.normalize(record?.encoder_status?.date_updated) ? new Date(Num.normalize(record?.encoder_status?.date_updated)!) : undefined
    };

    const transfer = {
        up: Num.normalize(record?.encoder_status?.internet_speed_upload),
        down: Num.normalize(record?.encoder_status?.internet_speed_download)
    };

    const transferConfig = {
        badUp: Num.normalize(record?.encoder_configs?.bad_internet_speed_upload),
        badDown: Num.normalize(record?.encoder_configs?.bad_internet_speed_download)
    };

    if (!Obj.isHydrated(obj) || !Obj.isHydrated(transfer) || !Obj.isHydrated(transferConfig)) {
        return undefined;
    }

    const nextEvent = {
        id: Str.normalize(record?.nextEvent?.id),
        startTime: record?.nextEvent?.start_time ? new Date(record.nextEvent.start_time) : undefined,
        endTime: record?.nextEvent?.end_time ? new Date(record.nextEvent.end_time) : undefined,
        name: Str.normalize(record?.nextEvent?.name)
    };

    const device = { ...obj, transfer, transferConfig };

    if (Obj.isHydrated(nextEvent)) {
        return { ...device, nextEvent: { ...nextEvent, operatorName: Str.normalize(record?.nextEvent?.operator_name) } };
    }

    return device;
};
